import React from 'react';
import { Icon } from '@saviynt/design-system';

import './SaviSuggestionItem.css';

interface SaviSuggestionItemProps {
  suggestion: string;
  onClick: (text: string) => void;
  testId: string;
}

SaviSuggestionItem.default = {
  testId: '',
};

function SaviSuggestionItem({
  suggestion,
  onClick,
  testId,
}: SaviSuggestionItemProps): JSX.Element {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick(suggestion);
    }
  };

  return (
    <article className='Ispm-SaviSuggestionItem' data-testid={testId}>
      <div
        role='button'
        tabIndex={0}
        className='Ispm-SaviSuggestionItem-content'
        title={suggestion}
        onKeyDown={handleKeyDown}
        onClick={() => {
          onClick(suggestion);
        }}>
        <Icon kind='Comment' color='purple-200' size='xLarge' />
        <div className='Ispm-SaviSuggestionItem-content-text'>{suggestion}</div>
      </div>
    </article>
  );
}

export default SaviSuggestionItem;
